import BaseService from 'services/BaseService';
import DataHelpers from 'helpers/DataHelpers';

//-------------------------------------------------------------------------------------------------------------------

export default class DevTaskService
    extends BaseService {

    static async list(param) {
        if (param) {
            param = { ...param };
            param.statuses = DataHelpers.convertIDList(param.statuses);
            param.tagIDs = DataHelpers.convertIDList(param.tagIDs);
        }
        return BaseService.callAPI('dev-task/list', param);
    }

    static async get(id) {
        return BaseService.callAPI('dev-task/get/' + id);
    }

    static async save(devTask) {
        return BaseService.callAPI('dev-task/save', devTask);
    }

    static async delete(id) {
        return BaseService.callAPI('dev-task/delete/' + id);
    }

    static listStatuses() {
        return [
            'New',
            'Queued',
            'WorkingOn',
            'NeedMoreInfo',
            'DoneOnDev',
            'Testing',
            'Live',
            'OnHold'
        ];
    }

    static getStatusFriendly(status) {
        switch (status) {
            case 'WorkingOn': return 'Working on';
            case 'NeedMoreInfo': return 'Need more info';
            case 'DoneOnDev': return 'Done on dev';
            case 'OnHold': return 'On hold';
        }
        return status;
    }

}
